// AAGUID-to-provider lookup table.
// This table covers the most common authenticators. Extend it as needed.
// AAGUIDs not in this table fall back to a generic "Passkey" label.

const NULL_AAGUID = '00000000-0000-0000-0000-000000000000';

// Each entry: { name, icon } (icon not currently used, but could be added in the future)
// Icons are Material Icons supported by the VA Design System va-icon component.
const PROVIDERS = {
  // Apple
  'fbfc3007-154e-4ecc-8c0b-6e020557d7bd': {
    name: 'Apple Passwords',
  },

  // Microsoft — Windows Hello
  '08987058-cadc-4b81-b6e1-30de50dcbe96': {
    name: 'Windows Hello',
  },
  '9ddd1817-af5a-4672-a2b9-3e3dd95000a9': {
    name: 'Windows Hello',
  },
  '6028b017-b1d4-4c02-b4b3-afcdafc96bb2': {
    name: 'Windows Hello',
  },

  // Google
  'ea9b8d66-4d01-1d21-3ce4-b6b48cb575d4': {
    name: 'Google Password Manager',
  },

  // Browser authenticators
  'adce0002-35bc-c60a-648b-0b25f1f05503': {
    name: 'Chrome on Mac',
  },
  'b5397666-4885-aa6b-cebf-e52262a439a2': {
    name: 'Chromium Browser',
  },

  // 1Password
  'bada5566-a7aa-401f-bd96-45619a55120d': {
    name: '1Password',
  },

  // Bitwarden
  'd548826e-79b4-db40-a3d8-11116f7e8349': {
    name: 'Bitwarden',
  },

  // Dashlane
  '531126d6-e717-415c-9320-3d9aa6981239': {
    name: 'Dashlane',
  },

  // Yubico
  '2fc0579f-8113-47ea-b116-bb5a8db9202a': {
    name: 'YubiKey',
  },
  '73bb0cd4-e502-49b8-9c6f-b59445bf720b': {
    name: 'YubiKey',
  },
  'a4e9fc6d-4cbe-4758-b8ba-37598bb5bbaa': {
    name: 'YubiKey',
  },
  '6d44ba9b-f6ec-2e49-b930-0c8fe920cb73': {
    name: 'YubiKey',
  },
};

const UNKNOWN_PROVIDER = {
  name: 'Other passkey',
};

/**
 * Returns the provider name and icon for a given AAGUID.
 * Falls back to a generic "Passkey" entry for unknown or null AAGUIDs.
 */
export function getPasskeyProvider(aaguid) {
  if (!aaguid || aaguid === NULL_AAGUID) return UNKNOWN_PROVIDER;
  return PROVIDERS[aaguid.toLowerCase()] || UNKNOWN_PROVIDER;
}
